<template>
  <section>
    <div class="pop-room material-detail-pop" v-if="materialInventoryDetailStatus">
      <a href="javascript:;" @click="closeDetailStatus()" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <h3 class="title">材料盘点情况登记表</h3>
        <el-col :span="23" v-if="form">
          <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;overflow:hidden;">
            <el-form-item label="所属仓库:">
              <router-link class="link" target="_blank" :to="'/Storage/Detail/'+form.house.id">
                {{form.house.name}}
              </router-link>
            </el-form-item>

            <el-form-item label="盘点登记员:">
              <user-info :userData='form.creator'></user-info>
            </el-form-item>
            <el-form-item label="盘点时间:">
              {{form.time}}
            </el-form-item>

            <el-form-item class="full" label="材料明细:">
              <div class="material-table">
                <strong class="green" v-if="form.materials.length<1">本次盘点情况良好，未产生任何盘存损益情况</strong>
                <el-table :data="form.materials" v-else border>
                  <el-table-column prop="number" label="材料编号">
                  </el-table-column>
                  <el-table-column prop="name" label="明细名称" width="240">
                  </el-table-column>
                  <el-table-column prop="dlName" label="材料类别" width="200">
                  </el-table-column>
                  <el-table-column label="盘点结果">
                    <template slot-scope="scope">
                      <strong :class="scope.row.type==1?'red':'green'">
                        {{ scope.row.type==1?'盘盈':'盘亏' }}
                      </strong>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" align="center" label="数量">
                    <template slot-scope="scope">
                      {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="unitName" align="center" label="计量单位">
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    computed: {
      total: function () {
        var _total = 0
        for (var i = 0; i < this.form.materials.length; i++) {
          var _item = this.form.materials[i]
          _total += _item.totalPrice / 1
        }
        return _total
      }
    },
    props: ['materialInventoryDetailStatus', 'form'],
    data() {
      return {
        // total: ''  
      }
    },
    methods: {
      closeDetailStatus() {
        this.$emit("hideMaterialInventoryDetail")
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/storage/components/materialInventoryDetail.vue